import React from 'react';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { unicodeToChar } from '@jwp/ott-common/src/utils/common';
import env from '@jwp/ott-common/src/env';

import Footer from '../../components/Footer/Footer';

const FooterContainer = () => {
  const configFooterText = useConfigStore(({ config }) => config.styling?.footerText);
  const footerText = configFooterText || unicodeToChar(env.APP_FOOTER_TEXT);

  return !!footerText && <Footer text={footerText} />;
};

export default FooterContainer;
